import {
  fetchRepositoryFromServer,
  type RepositoryPickerRepository,
  repositoryQueryKey,
} from '@github-ui/item-picker/RepositoryPicker'
import {useQuery} from '@github-ui/react-query'

export function useRepoQuery({owner, repo}: {owner?: string; repo?: string}) {
  return useQuery<RepositoryPickerRepository | null>({
    queryKey: repositoryQueryKey(owner ?? '', repo ?? ''),
    queryFn: ({signal}) => {
      if (!owner || !repo) {
        return null
      }

      return fetchRepositoryFromServer(owner, repo, signal)
    },
  })
}
